import paths from "./paths";

const Icon = ({
	              fill = "currentColor",
	              size = 24,
	              stroke = "currentColor",
	              strokeWidth = 0,
	              strokeLinecap = "round",
	              strokeLinejoin = "round",
	              className = "",
	              icon,
	              viewBox,
	              ...rest
              }) => {
	const path = paths[icon] || icon;
	const d = typeof path === "string" ? path : path.d;
	viewBox = viewBox || path?.viewBox || "0 0 24 24";

	return d ? (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			className={className}
			fill={fill}
			viewBox={viewBox}
			stroke={stroke}
			width={`${size}px`}
			height={`${size}px`}
			{...rest}
		>
			<path
				strokeLinecap={strokeLinecap}
				strokeLinejoin={strokeLinejoin}
				strokeWidth={strokeWidth}
				d={d}
			/>
		</svg>
	) : null;
};

export default Icon;
